import { render, staticRenderFns } from "./Hotornot.vue?vue&type=template&id=4bea2b52&"
import script from "./Hotornot.vue?vue&type=script&lang=js&"
export * from "./Hotornot.vue?vue&type=script&lang=js&"
import style0 from "./Hotornot.vue?vue&type=style&index=0&id=4bea2b52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports